/* eslint-disable import/prefer-default-export */
import types from '../types/types';

export const getSelectedEstado = (estadoId, estadoName) => (dispatch) => {
  dispatch({
    type: types.selectEstado,
    estadoId,
    estadoName,
  });
};
